import Vue from "vue";
import VueRouter from 'vue-router'
import Login from '../components/Login'
import Logs from '../components/Logs';
import CourierManagement from '../components/CourierManagement';
import SelectFinalStatus from '../components/Status/SelectFinalStatus';
import UserLogs from '../components/UserLogs';
import SearchOrder from '../components/SearchOrder'

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {path: '/', component: SearchOrder, meta: {title: "Поиск заказа"}},
    {path: '/login', component: Login, meta: {title: "Авторизация"}},
    {path: '/search', component: SearchOrder, meta: {title: "Поиск заказа"}},
    {path: '/logs', component: Logs, meta: {title: "Журнал приложения"}},
    {path: '/user_logs', component: UserLogs, meta: {title: "Журнал"}},
    {path: '/courier_management', component: CourierManagement, meta: {title: "Пользователи"}},
    {path: '/select_final_status/', component: SearchOrder, meta: {title: "Поиск заказа"}}, // выбор статуса без ид невозможен поэтому директим на поиск заказа
    {path: '/select_final_status/:id', component: SelectFinalStatus, meta: {title: "Установка статуса"}},
  ]
});

export default router



// WEBPACK FOOTER //
// ./src/router/router.js